import { getStore } from '../store/store';

export function getOwaSessionAddedAccountCreatedTimestamp(userIdentity: string) {
    return getStore().owaSessionAddedAccountsTimestamps.get(userIdentity);
}

export function getEditorSessionAddedAccounts() {
    return getStore().editorSessionAddedAccounts;
}

export function getAccountErrorReferralAccounts() {
    return getStore().accountErrorReferralAccounts;
}

export function getConnectAccountAttempted() {
    return getStore().connectAccountAttempted;
}
